var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "close_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z",
    className: "close_svg__a"
  })), /*#__PURE__*/React.createElement("style", null, ".close_svg__a{fill:none}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z",
    className: "close_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#close_svg__a)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z",
    className: "close_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.763 5.094 9.864.2a.124.124 0 0 0-.1-.2H8.522a.26.26 0 0 0-.192.089L4.947 4.122 1.564.089A.25.25 0 0 0 1.372 0H.125a.124.124 0 0 0-.1.2l4.1 4.889L.03 9.983a.124.124 0 0 0 .1.2h1.242a.26.26 0 0 0 .192-.089l3.383-4.028L8.33 10.1a.25.25 0 0 0 .192.089h1.247a.124.124 0 0 0 .1-.2Z",
    style: {
      fill: "currentColor"
    },
    transform: "translate(3.047 2.906)"
  })));
};
export { SvgClose as ReactComponent };